import Button from "@/components/button";
import { Companies } from "@/redux/slices/plan";

interface CompaniesModalProps {
  companies: Companies[] | null;
  onClose: () => void;
}

export default function CompaniesModal({
  companies,
  onClose,
}: CompaniesModalProps) {
  if (!companies) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 backdrop-blur-md">
      <div className="w-full max-w-md rounded-shell border border-checkout-hairline bg-checkout-surface p-2">
        <div className="rounded-[calc(1.75rem-0.5rem)] bg-checkout-raised p-6">
          <p className="text-[11px] uppercase tracking-[0.2em] text-checkout-muted">
            Unidades
          </p>
          <h3 className="mt-2 font-display text-2xl font-semibold">
            Onde este plano é aceito
          </h3>
          <ul className="mt-6 max-h-72 space-y-3 overflow-y-auto">
            {companies.map((company, idx) => (
              <li
                key={`${company.IdSubscriptionDetailCompanies}-${idx}`}
                className="flex items-center gap-3 border-b border-checkout-hairline pb-3 text-sm text-checkout-fg last:border-0"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-[var(--tenant-accent-color)]" />
                {company.Company.Name}
              </li>
            ))}
          </ul>
          <Button className="mt-6 w-full" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </div>
  );
}
